export default __webpack_public_path__ + "static/mado-logo-659408d7ff356a2d896cf6cb6a70a143.svg";